module.exports = __webpack_public_path__ + "img/step1.1bfcec61.svg";